import { render } from "./FileSelectionCom.vue?vue&type=template&id=12c0e4ac&scoped=true"
import script from "./FileSelectionCom.vue?vue&type=script&lang=js"
export * from "./FileSelectionCom.vue?vue&type=script&lang=js"

import "./FileSelectionCom.vue?vue&type=style&index=0&id=12c0e4ac&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c0e4ac"]])

export default __exports__